import { defineComponent as u, getCurrentInstance as f, ref as r, computed as d } from "vue";
import { scrollIntoView as c } from "./index511.js";
import k from "./index22.js";
import b from "./index170.js";
import L from "./index31.js";
const y = u({
  name: "CsExpandableLinkList",
  components: {
    MsHeadline: b,
    CsExpander: k,
    CsLinkGroup: L
  },
  props: {
    headline: String,
    links: Array,
    amountInitialVisibleLinks: {
      type: Number,
      default: 1 / 0
    }
  },
  setup(n) {
    var t, a, l;
    const e = (t = f()) == null ? void 0 : t.proxy, i = r(!1);
    function o() {
      i.value = !i.value, i.value || c(e == null ? void 0 : e.$el, { behavior: "smooth" });
    }
    const m = d(() => i.value ? 1 / 0 : n.amountInitialVisibleLinks), s = ((a = n == null ? void 0 : n.links) == null ? void 0 : a.length) && ((l = n == null ? void 0 : n.links) == null ? void 0 : l.length) > n.amountInitialVisibleLinks;
    return {
      amountVisibleLinks: m,
      showExpander: s,
      expanded: i,
      toggle: o
    };
  }
});
export {
  y as default
};
